import React, {useContext, useState} from 'react';
import CloseIcon from '@material-ui/icons/Close';
import Image from 'next/image';
import PuStackWhiteLogo from "../../../public/assets/images/logoDark.webp";
import PuStackLightLogo from "../../../public/assets/images/logo.webp";
import RejectedImage from '../../../public/assets/scholarship/scholarship_rejected.svg';
import { ThemeContext, PustackProContext } from "../../../context";
import {Scholarship} from '../../../containers/global/pro-slider';
import {circularProgress} from "../../../public/assets";
import Lottie from 'lottie-react-web';

interface PropTypes {
	scholarshipRef: React.MutableRefObject<Scholarship>;
	setActiveIndex?: React.Dispatch<React.SetStateAction<number>>;
	setOpenCriteriaModal?: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function DeniedScreen({scholarshipRef, setOpenCriteriaModal, setActiveIndex}: PropTypes) {
	const [isDark] = useContext(ThemeContext).theme;
	const [,setProSliderOpen] = useContext(PustackProContext).value;
	const [loading, setLoading] = useState(false);

	const applyAgain = async () => {
		setLoading(true);
		await scholarshipRef.current.applyAgain();
		setLoading(false);
		setActiveIndex(1);
	}

	return (
		<div className="successful-submission">
			<div
				className="close__wrapper"
				onClick={() => {
					setProSliderOpen(false);
					// setOrderStatus(false);
				}}
				style={{cursor: 'pointer'}}
			>
				<CloseIcon className="close__icon" />
			</div>
			<div className="successful-submission-logo">
				<Image width={100} height={100} src={isDark ? PuStackWhiteLogo : PuStackLightLogo} alt="Pustack"/>
			</div>
			<div className="successful-submission-content">
				<Image src={RejectedImage} width={100} height={100} alt={"Scholarship under review"} />
				<h3>Scholarship Denied</h3>
				<p style={{marginBottom: '4px'}}>You do not qualify for the Jeet Foundation Scholarship.</p>
				<p>Please review the <span onClick={() => setOpenCriteriaModal(true)} style={{color: 'dodgerblue', textDecoration: 'underline', cursor: 'pointer'}}>criteria</span>.</p>
			</div>
			<button className="successful-submission-btn" onClick={() => {
				applyAgain();
			}}>{loading ? (
				<Lottie
					style={{
						height: '25px',
						// position: 'absolute',
						// top: '50%',
						// left: '50%',
						// transform: 'translate(-50%, -50%)',
					}}
					options={{
						animationData: circularProgress,
						loop: true,
					}}
				/>
			) : 'Apply again'}</button>
		</div>
	)
}
